//#region src/getSharedFallbackGetter.ts
var getSharedFallbackGetter = (param)=>{
    var shareKey = param.shareKey, factory = param.factory, version = param.version, webpackRequire = param.webpackRequire, _param_libraryType = param.libraryType, libraryType = _param_libraryType === void 0 ? "global" : _param_libraryType;
    var _webpackRequire_federation = webpackRequire.federation, runtime = _webpackRequire_federation.runtime, instance = _webpackRequire_federation.instance, bundlerRuntime = _webpackRequire_federation.bundlerRuntime, sharedFallback = _webpackRequire_federation.sharedFallback;
    if (!sharedFallback) return factory;
    var fallbackItems = sharedFallback[shareKey];
    if (!fallbackItems) return factory;
    var fallbackItem = version ? fallbackItems.find((item)=>item[1] === version) : fallbackItems[0];
    if (!fallbackItem) throw new Error(`No fallback item found for shareKey: ${shareKey} and version: ${version}`);
    return ()=>runtime.getRemoteEntry({
            origin: webpackRequire.federation.instance,
            remoteInfo: {
                name: fallbackItem[2],
                entry: `${webpackRequire.p}${fallbackItem[0]}`,
                type: libraryType,
                entryGlobalName: fallbackItem[2],
                shareScope: "default"
            }
        }).then((shareEntry)=>{
            if (!shareEntry) throw new Error(`Failed to load fallback entry for shareKey: ${shareKey} and version: ${version}`);
            return shareEntry.init(webpackRequire.federation.instance, bundlerRuntime).then(()=>shareEntry.get());
        });
};
//#endregion
exports.getSharedFallbackGetter = getSharedFallbackGetter; //# sourceMappingURL=getSharedFallbackGetter.cjs.map
